var isMobile = new Object();
isMobile.Android = function () {
	return navigator.userAgent.match(/Android/i);
};

isMobile.BlackBerry = function () {
	return navigator.userAgent.match(/BlackBerry/i);
};
isMobile.iOS = function () {
	return navigator.userAgent.match(/iPhone|iPad|iPod/i);
};

isMobile.iPad = function () {
	return navigator.userAgent.match(/iPad/i);
};
isMobile.Opera = function () {
	return navigator.userAgent.match(/Opera Mini/i);
};
isMobile.Windows = function () {
	return navigator.userAgent.match(/IEMobile/i);
};

isMobile.Firefox = function () {
	return navigator.userAgent.match(/Firefox/gi);
};
isMobile.InternetExplorer = function () {
	return navigator.userAgent.match(/MSIE/gi);
};
isMobile.Opera = function () {
	return navigator.userAgent.match(/Opera/gi);
};
isMobile.Safari = function () {
	return navigator.userAgent.match(/Safari/gi);
};
isMobile.any = function () {
	return (
		isMobile.Android() ||
		isMobile.BlackBerry() ||
		isMobile.iOS() ||
		isMobile.Opera() ||
		isMobile.Windows()
	);
};
if (isMobile.any() && isMobile.iPad() == null) {
	//return;
}

var ua = window.navigator.userAgent;
var is_ie = /MSIE|Trident/.test(ua);

/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

var winWT = $(window).innerWidth();
var winHT = $(window).innerHeight();

var disableScrolling = function () {
	var x = window.scrollX;
	var y = window.scrollY;
	window.onscroll = function () { window.scrollTo(x, y); };
}
var enableScrolling = function () {
	window.onscroll = function () { };
}
window.onbeforeunload = function () {
	window.scrollTo(0, 0);
}

$(window).on('load', function () {
	window.scrollTo(0, 0);
});

var winWT = $(window).width();
$(window).on('load', function () {
	// AOS On Scroll Reveal
	$(function () {
		AOS.init({
			easing: 'ease-out-in',
			duration: 1200,
			/* disable: function () {
				var maxWidth = 1023;
				return window.innerWidth > maxWidth;
			} */
		});
	});
	/* if ((winWT <= 1023)) {
		$(function () {
			AOS.init({
				easing: 'ease-out-in',
				duration: 1200,
				disable: function () {
					var maxWidth = 1023;
					return window.innerWidth > maxWidth;
				}
			});
		});
	} else {
		$(function () {
			AOS.init({
				disable: function () {
					var maxWidth = 1023;
					return window.innerWidth > maxWidth;
				}
			});
		});
	}; */
});

$(document).ready(() => {
	$(".slimmenu").slimmenu({
		resizeWidth: '1200',
		collapserTitle: '',
		animSpeed: '500',
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: '&nbsp;'
	});

	var navWT = $("header .navigation").innerWidth();
	$(".nav-icon").on('click', function () {
		//return;
		if ($(this).hasClass("open")) {
			resetMobileMenu();
		} else {
			$(this).addClass("open");
			$("header .navigation").animate({ right: 0 }, 300);
			$('.menu_overlay').css({ display: 'block' });
			$('body').css({ overflow: 'hidden' });
			$('.overlay').css({ display: 'block' });
		}
	});

	$('header .overlay').on('click', function () {
		resetMobileMenu();
	});

	function resetMobileMenu() {
		$(".nav-icon").removeClass("open");
		$("header .navigation").animate({ right: -navWT + "px" }, 300);
		$('.menu_overlay').css({ display: 'none' });
		$('body').css({ overflowY: 'scroll' });
		$('.overlay').css({ display: 'none' });
	}

	function closeNavMobile() {
		if (winWT <= 1100) {
			$('nav a').on('click', function () {
				resetMobileMenu();
			});
		}
	}
	closeNavMobile();

	var headerHT = $('header').innerHeight();
	function setTopGutterSpace() {
		$('#wrapper').css({ 'padding-top': headerHT + 'px' });
	}
	//setTopGutterSpace();

	
	/**************************************************************/
	/**************************************************************/

	$(window).resize(function () {
		winWT = $(window).width();
		headerHT = $('header').innerHeight();
		setRotateMsgForMobile();
		//setTopGutterSpace();
		closeNavMobile();
	});

	function setRotateMsgForMobile() {
		winWT = $(window).innerWidth();
		if (winWT < 1024) {
			// Define a function to handle orientation changes
			function handleOrientationChange(event) {
				const isLandscape = event.matches;
				$(".rotate-msg").css("display", isLandscape ? "block" : "none");
			}
			// Create a media query for landscape orientation
			const landscapeMediaQuery = window.matchMedia("(orientation: landscape)");

			// Listen for changes in orientation using the media query
			landscapeMediaQuery.addListener(handleOrientationChange);

			// Initial check
			handleOrientationChange(landscapeMediaQuery);
		}
	}
	setRotateMsgForMobile();



	/*================================================================*/
	let slider = $(".banner-slider");
	/* $(".banner-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		speed: 1000,
		cssEase: 'ease-out',
		pauseOnFocus: false,
		pauseOnHover: false,
		swipeToSlide: false,
		draggable: false,
		arrows : false,
		dots:false,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			}
		]
	}); */

	/* Init Animation */
	function initAnimation(){
		const tlInitAnim = gsap.timeline();
		gsap.set('.title img', { opacity:0, y:-50+'%'});
		gsap.set('.title span', { opacity:0, y:50});
		gsap.set('.models', { opacity:0});

		tlInitAnim.to('.title img', { opacity:1, y:0, duration:0.8, ease: "power1.inOut"}, 'initAnim')
				.to('.title span', { opacity:1, y:0, duration:0.8, stagger:0.1, ease: "power1.inOut"}, 'initAnim-=0.2s')
				.fromTo('.title p', { opacity:0, y:30},{ opacity:1, y:0, duration:0.6, ease: "power1.inOut"}, 'initAnim+=0.4s')
				.fromTo('.banner-hld', { opacity:0, y:-30},{ opacity:1, y:0, duration:0.6, ease: "power1.inOut"}, 'initAnim+=0.6s')
				//.to('.models', { opacity:1, duration:0.6, ease: "power1.inOut"}, 'initAnim+=0.4s')
				.set('.cards-hld', { opacity:1}, 'initAnim+=0.6s')
				.fromTo('.card-con',{ opacity:0, x:50}, { opacity:1, x:0, duration:0.7, stagger:0.3, ease: "power1.inOut"}, 'initAnim+=0.2s')
				.to('.form-hld', { opacity:1, duration:0.4, ease: "power1.inOut-=0.5"})
				//.fromTo('.banner-slider .item',{ opacity: 0, y:-100+'%'}, { opacity:1, y:0, duration: 0.5, stagger:0.2} , 'initAnim+=0.4s')
	}

	function initAnimationMob(){
		const tlInitAnimMob = gsap.timeline();
		gsap.set('.title img', { opacity:0, y:-50+'%'});
		gsap.set('.title span', { opacity:0, y:50});
		gsap.set('.models', { opacity:0});

		tlInitAnimMob.to('.title img', { opacity:1, y:0, duration:0.8, ease: "power1.inOut"}, 'initAnim')
				.to('.title span', { opacity:1, y:0, duration:0.8, stagger:0.1, ease: "power1.inOut"}, 'initAnim-=0.2s')
				.fromTo('.title p', { opacity:0, y:30},{ opacity:1, y:0, duration:0.8, stagger:0.1, ease: "power1.inOut"}, 'initAnim+=0.2s')
				.set('.cards-hld', { opacity:1}, 'initAnim+=0.4s')
				.fromTo('.cards-hld .card-02',{  opacity:0}, { opacity:1, duration:0.7, ease: "power1.inOut"}, 'initAnim+=0.2s')
				.fromTo('.cards-hld .card-01',{  y:40}, { opacity:1, y:0, duration:0.7, ease: "power1.inOut"}, 'initAnim+=0.8s')
				.fromTo('.cards-hld .card-03',{  y:-40}, { opacity:1, y:0, duration:0.7, ease: "power1.inOut"}, 'initAnim+=0.8s')
				.fromTo('.form-hld',{  opacity:0,y : 40}, { opacity:1, y: 0, duration:0.8, ease: "power1.inOut"},'initAnim+=1s')
	}
	

	screenAnim();
	function screenAnim() {
		winWT = $(window).width();

		if(winWT > 1023){
			initAnimation();
			
		}else{
			initAnimationMob();
		}
		
	}


});